<template>
    <div id="popup" :class="{ 'popup--inactive': !isPopupActive }">
        <div class="popup__wrapper">
            <div
                class="popup__container"
                :class="{ 'popup__container--inactive': !isPopupActive }"
            >
                <div class="popup__header">
                    <div class="popup__header-container">
                        <h3 class="popup__header-title">
                            Introducing <br />
                            Thetanuts Stronghold
                        </h3>
                        <span>
                            Stronghold earns yields by running an automated
                            index of call or put strategies. Earnings are
                            auto-compounded.
                        </span>
                    </div>
                </div>

                <div class="popup__content">
                    <div class="popup__content-image">
                        <img
                            src="/images/popup/new-stronghold/lists-benefits.svg"
                        />
                    </div>

                    <div class="popup__checkbox-container">
                        <input
                            type="checkbox"
                            class="popup__checkbox-input"
                            :checked="isChecked"
                            @click="toggleCheckbox()"
                            id="never-show-again"
                        />
                        <div class="popup__checkbox-text">
                            <label for="never-show-again"
                                >Do not show again</label
                            >
                        </div>
                    </div>
                </div>

                <div class="popup__close-image" @click="closePopup()">
                    <img
                        class="popup__close"
                        src="/images/popup/close-icon.svg"
                    />
                </div>

                <a
                    href="https://stronghold.thetanuts.finance/"
                    target="_blank"
                    style="display: block;"
                >
                    <div class="popup__button-container">
                        <span>Thetanuts Stronghold</span>
                        <img
                            src="/images/popup/icon-arrow-right-black-bg-white.svg"
                        />
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isPopupActive: true,
            isChecked: false
        };
    },
    methods: {
        closePopup() {
            this.isPopupActive = false;

            if (this.isChecked) {
                localStorage.setItem(
                    "popup-stronghold-never-show-again",
                    "true"
                );
            }
        },
        toggleCheckbox() {
            this.isChecked = !this.isChecked;

            if (this.isChecked) {
                localStorage.setItem(
                    "popup-stronghold-never-show-again",
                    "true"
                );
            } else {
                localStorage.removeItem("popup-stronghold-never-show-again");
            }
        }
    },
    mounted() {
        if (
            localStorage.getItem("popup-stronghold-never-show-again") === "true"
        ) {
            this.isPopupActive = false;
        }
    }
};
</script>

<style lang="scss" scoped>
#popup {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1000;
    backdrop-filter: blur(3px);
    transition: opacity ease-in-out 0.75s, z-index 1s step-end;
    zoom: 0.7;

    @media only screen and (min-width: 375px) {
        zoom: 0.8;
    }
    @media only screen and (min-width: 425px) {
        zoom: 0.9;
    }
    @media only screen and (min-width: 500px) {
        zoom: 1;
    }

    &.popup--inactive {
        opacity: 0;
        z-index: -1;
    }

    .popup__wrapper {
        position: relative;
        height: 100%;
        width: 100%;

        .popup__container {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 450px;
            height: 539px;
            background: linear-gradient(
                233.05deg,
                rgb(82, 174, 0) 12.88%,
                rgb(23, 165, 197) 85.14%
            );
            border-radius: 16px;
            color: rgb(255, 255, 255);
            padding: 30px 25px;
            display: flex;
            flex-direction: column;
            transition: top ease-in-out 0.75s, opacity ease-in-out 0.75s;

            &.popup__container--inactive {
                opacity: 0;
                top: 40%;
            }

            .popup__header {
                display: flex;
                flex-direction: column;
                align-items: center;

                .popup__header-container {
                    font-family: "Sofia Sans";
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    letter-spacing: 0em;
                    text-align: center;
                    display: block;

                    .popup__header-title {
                        font-family: "Work Sans";
                        font-size: 34px;
                        font-weight: 700;
                        line-height: 36px;
                        letter-spacing: 0em;
                        text-align: center;
                    }
                }
            }

            .popup__content {
                flex-grow: 1;
                background-image: url("/images/popup/new-stronghold/bg-tadaa.png");
                background-repeat: no-repeat;
                background-position: center center;

                .popup__content-image {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                }
                .popup__checkbox-container {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: -30px;
                    font-family: "Work Sans";
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 19px;
                    letter-spacing: 0em;
                    text-align: left;

                    .popup__checkbox-input {
                        border: 1px solid rgb(255, 255, 255);
                        box-shadow: none;
                        background: none;
                        width: 22px;
                        height: 22px;
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        appearance: none;
                        border-radius: 4px;
                        cursor: pointer;
                        position: relative;

                        &:checked {
                            background: rgba(40, 40, 40, 0.7);
                            color: #fff;
                            border: solid 1px #363636;
                        }
                    }

                    .popup__checkbox-text {
                        margin-left: 15px;

                        * {
                            margin: 0;
                            user-select: none;
                        }
                        label {
                            cursor: pointer;
                        }
                    }
                }
            }

            .popup__close-image {
                position: absolute;
                right: 12px;
                top: 12px;

                .popup__close {
                    cursor: pointer;

                    &:hover {
                        opacity: 0.8;
                    }
                }
            }

            .popup__button-container {
                position: absolute;
                bottom: calc(0px - (59px / 2));
                left: 50%;
                transform: translateX(-50%);
                height: 59px;
                display: flex;
                background-color: #293841;
                width: 85%;
                border-radius: 100px;
                align-items: center;
                justify-content: center;
                font-family: Sofia Sans;
                font-size: 24px;
                font-weight: 700;
                line-height: 29px;
                letter-spacing: 0em;
                text-transform: uppercase;
                cursor: pointer;

                span {
                    background-image: linear-gradient(
                        95.12deg,
                        #1cc8c1 0%,
                        #05feb1 0.01%,
                        #d9ef46 28.64%,
                        #ff843f 49.48%,
                        #a2f9e4 73.96%,
                        #05feb1 100%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;

                    background-size: 300%;
                    background-position: -100%;

                    animation: animatedText 5s infinite alternate-reverse;
                }

                img {
                    margin-left: 10px;
                }
            }
        }
    }
}

/**
    * Animation for the text    
*/

@keyframes animatedText {
    to {
        background-position: 100%;
    }
}
</style>
